import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import BoardListPage from '@/pages/board';
import BoardPage from '@/pages/board/page';
import PlatformsPage from '@/pages/platforms';
import AdminPage from '@/pages/admin';
import AdminHubPage from '@/pages/admin/hub';
import ReliabilityConsolePage from '@/pages/admin/reliability';
import BusinessConsolePage from '@/pages/admin/business';
import SupportConsolePage from '@/pages/admin/support';
import MePage from '@/pages/me';
import CreatePage from '@/pages/create';
import ReplyToolPage from '@/pages/reply';
import StudioPage from '@/pages/studio';
import RoleVideoPage from '@/pages/role-video';
import WorkbenchPage from '@/pages/workbench';
import MaterialsIndexPage from '@/pages/materials';
import MaterialsPage from '@/pages/materials/page';
import QueuePage from '@/pages/queue';
import RoleGate from '@/components/RoleGate';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <WorkbenchPage />,
  },
  {
    path: '/board',
    element: <BoardListPage />,
  },
  {
    path: '/board/:characterId',
    element: <BoardPage />,
  },
  {
    path: '/platforms',
    element: <PlatformsPage />,
  },
  {
    path: '/admin',
    element: <AdminHubPage />,
  },
  {
    path: '/admin/reliability',
    element: <ReliabilityConsolePage />,
  },
  {
    path: '/admin/business',
    element: <BusinessConsolePage />,
  },
  {
    path: '/admin/support',
    element: <SupportConsolePage />,
  },
  {
    path: '/admin/operations',
    element: (
      <RoleGate allow={['dev_admin', 'super_admin']} deniedTitle="此页仅限管理员">
        <AdminPage />
      </RoleGate>
    ),
  },
  {
    path: '/queue',
    element: <QueuePage />,
  },
  {
    path: '/me',
    element: <MePage />,
  },
  {
    path: '/create',
    element: <CreatePage />,
  },
  {
    path: '/reply',
    element: <ReplyToolPage />,
  },
  {
    path: '/studio',
    element: <StudioPage />,
  },
  {
    path: '/role-video',
    element: <RoleVideoPage />,
  },
  {
    path: '/materials',
    element: <MaterialsIndexPage />,
  },
  {
    path: '/materials/:characterId',
    element: <MaterialsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
